import {createAction} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import {getIntersectedCPSelection, getTaskNameFilter, getTaskStatusFilter, isShowOnlyManageableTasks} from '../common/selectors'
import {getShownColumnsWithOrder, getTasksSorting} from '../tasksTable/selectors'
import rpcCall from '../../util/rpc/rpcCalls'
import {convertTaskListAndSaveAsCsv} from './utils'
import {afterTaskListExportRequestFailed} from '../syncCallbacks'
import {isTWSEnabled} from '../../features/selectors'

const setExportInProgress = createAction(ActionTypes.CSV_EXPORT_IN_PROGRESS_SET)

export const exportTaskListCsv = () => (dispatch, getState) => {
    dispatch(setExportInProgress(true))
    const state = getState()
    const columnsWithOrder = getShownColumnsWithOrder(state)
    const taskSorting = getTasksSorting(state)
    const requestParams = [
        getIntersectedCPSelection(state),
        getTaskStatusFilter(state),
        getTaskNameFilter(state),
        isShowOnlyManageableTasks(state),
        taskSorting.by,
        taskSorting.asc,
        0,
        null
    ]
    rpcCall('TaskManagementService.getTasks', requestParams, (error) => false, 'TaskManagementService.exportTasksCsv')
        .then((data) => {
            convertTaskListAndSaveAsCsv(data, columnsWithOrder, isTWSEnabled(state))
            dispatch(setExportInProgress(false))
        })
        .catch((err) => {
            dispatch(setExportInProgress(false))
            afterTaskListExportRequestFailed(err)
        })
}



// WEBPACK FOOTER //
// ./web/js/taskManagement/exportCsv/actions.js